import {Navbar} from "react-bootstrap";

export function Footer(){
    return (
        <Navbar bg="light" className="justify-content-center" expand="lg">
            <Navbar.Text>Copyright © 2021 The Machine .Dev</Navbar.Text>
        </Navbar>
    );
}
